import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type {
  SsnTraceConsumerSegment,
  SsnTraceReportSliceState,
  SsnTraceReportStatus,
} from './types';

const initialState: SsnTraceReportSliceState = {
  status: null,
  createdAt: null,
  records: [],
};

interface SetReportPayload {
  status: SsnTraceReportStatus;
  createdAt?: string | null;
  records?: SsnTraceConsumerSegment[];
}

const ssnTraceReportSlice = createAppSlice({
  name: 'ssnTraceReport',
  initialState,
  reducers: {
    setSsnTraceReport(state, action: PayloadAction<SetReportPayload>) {
      const { payload } = action;
      state.status = payload.status;
      state.createdAt = payload.createdAt ?? null;
      state.records = payload.records ?? [];
    },
    clearSsnTraceReport() {
      return {
        status: null,
        createdAt: null,
        records: [],
      };
    },
  },
});

export const { setSsnTraceReport, clearSsnTraceReport } =
  ssnTraceReportSlice.actions;

export default ssnTraceReportSlice.reducer;
